exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leo-operator-assistant-fab[data-v-000199f9] {\r\n  position: fixed;\r\n  right: 24px;\r\n  bottom: 88px;\r\n  z-index: 1900;\r\n  border: none;\r\n  border-radius: 999px;\r\n  padding: 10px 16px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, #409eff, #337ecc);\r\n  -webkit-box-shadow: 0 4px 14px rgba(64, 158, 255, 0.45);\r\n          box-shadow: 0 4px 14px rgba(64, 158, 255, 0.45);\r\n  cursor: pointer;\n}\n.leo-operator-assistant-fab[data-v-000199f9]:hover {\r\n  -webkit-filter: brightness(1.05);\r\n          filter: brightness(1.05);\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-000199f9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LeoKnowledge/LeoTrainingOperatorAssistantHost.vue
// module id = qXJj
// module chunks = 446